<template>
    <CommonComponentsProductsTitleFunctionTitle
        :function-title="data.functionTitle"
        :color-index="data.functionTitleColorIndex"
        class="digital-procedure-title"
    />
    <CommonComponentsProductsFabricTimeline v-model="curTimelineIndex" :timeline-data="data.timelineData" />
</template>

<script lang="ts" setup>
    import procedure1Video from '@assets/Video/products/fabric/procedure1.mp4';
    import procedure2Video from '@assets/Video/products/fabric/procedure2.mp4';
    import procedure3Video from '@assets/Video/products/fabric/procedure3.mp4';
    import procedure1VideoPoster from '@assets/Video/products/fabric/procedure1.jpg';
    import procedure2VideoPoster from '@assets/Video/products/fabric/procedure2.jpg';
    import procedure3VideoPoster from '@assets/Video/products/fabric/procedure3.jpg';
    const curTimelineIndex = ref(0);

    const data = reactive({
        functionTitle: {
            colorTitle: 'global_fabric_colorTitle',
            title: 'global_fabric_title_0',
            subTitle: 'global_fabric_subTitle_0',
        },
        functionTitleColorIndex: 1,
        timelineData: [
            {
                title: 'global_fabric_content_text_00',
                mediaPath: procedure1Video,
                poster: procedure1VideoPoster,
            },
            {
                title: 'global_fabric_content_text_01',
                mediaPath: procedure2Video,
                poster: procedure2VideoPoster,
            },
            {
                title: 'global_fabric_content_text_02',
                mediaPath: procedure3Video,
                poster: procedure3VideoPoster,
            },
        ],
    });
</script>

<style lang="less" scoped>
    .digital-procedure-title {
        margin-bottom: .convert(100px) [ @vw];
        padding: 0 .convert(80px) [ @vw] 0 .convert(80px) [ @vw];
    }
</style>
